import React from 'react'
import { Button, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'

export default function AttachImageWithoutTreeUpdatesButton({ noPersonsState = false }) {
  const { t } = useTranslation()
  const { openOverlay } = useOverlayContext()
  const BUTTON_TEXT = t('onlyAttachImageButton.label', 'Attach Image as a source')
  const NO_PERSON_STATE_BUTTON_TEXT = t(
    'attachImageWithoutTreeUpdatesButton.noPersonsStateLabel',
    'Attach Image as a source'
  )

  const handleClick = () => {
    openOverlay('attachToTreeOverlay')
  }

  return (
    <Row alignX="center">
      <Button
        emphasis="low"
        onClick={handleClick}
        data-testid="attach-image-without-tree-updates-button"
        linkName="AttachImageWithoutTreeUpdates"
      >
        {noPersonsState ? NO_PERSON_STATE_BUTTON_TEXT : BUTTON_TEXT}
      </Button>
    </Row>
  )
}
